import { render, staticRenderFns } from "./Delta.vue?vue&type=template&id=e5ccf5ba&"
import script from "./Delta.vue?vue&type=script&lang=js&"
export * from "./Delta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports